

























import { Component, Prop, Vue } from 'vue-property-decorator';
import { MentoringTopCard, MentoringMain } from './components';
import {
  MentoringCardFooter,
  MentoringSmallText as Small,
} from '../components';
import { CURRENT, COMPLEETED, ROLLUP, DETAILS, UNKNOWN } from './consts';
import { Meetings, IMentoringProgramCard, Member, PopupData } from './types';

@Component({
  components: {
    Small,
    MentoringMain,
    MentoringTopCard,
    MentoringCardFooter,
  },
})
export default class MentoringProgramCard
  extends Vue
  implements IMentoringProgramCard {
  @Prop({ type: Number, default: 0 })
  readonly index!: number;

  @Prop({ type: String, default: '' })
  readonly status!: string;

  @Prop({ type: String, default: '' })
  readonly teamTitle!: string;

  @Prop({ type: String, default: '' })
  readonly title!: string;

  @Prop({ type: Object, default: () => {} })
  readonly curator!: Member;

  @Prop({ type: Object, default: () => {} })
  readonly mentor!: Member;

  @Prop({ type: String, default: '' })
  readonly startDate!: string;

  @Prop({ type: String, default: '' })
  readonly endDate!: string;

  @Prop({ type: Array, default: () => [] })
  readonly list!: Meetings;

  public isOpenList: boolean = this.index === 0;

  get btnText(): string {
    return this.isOpenList ? ROLLUP : DETAILS;
  }

  get isOpenStatus(): boolean {
    return this.status !== '3';
  }

  get isClosedStatus(): boolean {
    return this.status === '3';
  }

  get iconStatus() {
    return this.isOpenStatus ? 'open' : 'closed';
  }

  get statusText(): string {
    const { isClosedStatus, isOpenStatus } = this;
    return isOpenStatus ? CURRENT : isClosedStatus ? COMPLEETED : UNKNOWN;
  }

  get isCompleted(): string {
    const { isClosedStatus, isOpenStatus, endDate } = this;
    return isOpenStatus
      ? 'Не завершена'
      : isClosedStatus || endDate
      ? endDate
      : '';
  }

  toggleList(): void {
    this.isOpenList = !this.isOpenList;
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/profile/modules/mentoring/programcard/MentoringProgramCard.vue